/**
 * @see https://g.antv.antgroup.com/api/event/intro
 */
export enum OriginEventType {
  MOUSE_DOWN = 'mousedown',
  MOUSE_MOVE = 'mousemove',
  MOUSE_UP = 'mouseup',
  MOUSE_OUT = 'mouseout',
  MOUSE_LEAVE = 'mouseleave',
  TOUCH_START = 'touchstart',
  TOUCH_END = 'touchend',
  KEY_DOWN = 'keydown',
  KEY_UP = 'keyup',
  CLICK = 'click',
  HOVER = 'hover',
  CONTEXT_MENU = 'contextmenu',
  POINTER_DOWN = 'pointerdown',
  POINTER_MOVE = 'pointermove',
  POINTER_OUT = 'pointerout',
  POINTER_LEAVE = 'pointerleave',
  POINTER_UP = 'pointerup',
  POINTER_CANCEL = 'pointercancel',
  POINTER_ENTER = 'pointerenter',
  POINTER_OVER = 'pointerover',
  RIGHT_DOWN = 'rightdown',
  RIGHT_UP = 'rightup',
  SCROLL = 'scroll',
}
